import InputTuKhoa from './input-tukhoa';
import FormTimKiemNangCao from './form-nangcao';

export { InputTuKhoa, FormTimKiemNangCao }



// WEBPACK FOOTER //
// ./src/components/modules/reception/form-timkiem/index.js